import { DEFAULT_PAGE_SIZE } from 'components/common/DataGridDevEx/DataGrid.constants';
import { fetchGet, objectify } from '../utils';

export const fetchSummary = (query) => {
  const { TransactionNumber } = query;

  return fetchGet(`SalesOrderEnquiry/SalesOrder/SaleDeposits/${TransactionNumber}/DepositSummary`)
    .then((result) => result ? objectify(result.SaleDepositSummary) : null);
};

export const fetch = async (query: { TransactionNumber: string; Page: number; BatchSize?: number }): Promise<{ records: any[]; nextPage: boolean; currPage: number }> => {
  const { Page, TransactionNumber, BatchSize = DEFAULT_PAGE_SIZE } = query;
  const respType = 'Inline';

  return fetchGet(
    `SalesOrderEnquiry/SalesOrder/SaleDeposits/${TransactionNumber}/DepositDetails`,
    {
      BatchPage: Page,
      BatchSize
    },
    respType)
    .then(
      (result: {
        SaleDepositDetails: any[];
        BatchInformation: {
          BatchPage: number;
          EndOfData: boolean;
        };
      }) => {
        if (result) {
          if (result.SaleDepositDetails) {

            return {
              records: result.SaleDepositDetails.map((item: any) => objectify(item, null, 'Inline')),
              nextPage: result.BatchInformation && !result.BatchInformation.EndOfData,
              currPage: result.BatchInformation && result.BatchInformation.BatchPage,
            };
          }
        }

        return {
          records: [],
          nextPage: false,
          currPage: 1,
        };
      });
};
